import { render, staticRenderFns } from "./InsuranceInfo.vue?vue&type=template&id=f08391d2&scoped=true"
import script from "./InsuranceInfo.vue?vue&type=script&lang=js"
export * from "./InsuranceInfo.vue?vue&type=script&lang=js"
import style0 from "./InsuranceInfo.vue?vue&type=style&index=0&id=f08391d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08391d2",
  null
  
)

export default component.exports